function getCookie(name) {
  let cookie = {}
  document.cookie.split(';').forEach(function(el) {
    let [k,v] = el.split('=')
    cookie[k.trim()] = v
  })
  return cookie[name]
}

export function setCookie (name, value, domain, date) {
  const expires = '; max-age=' + 2592000
  let initialDomain = ''
  /* if (date) {
    expires = '; expires=' + date
  } */
  if (domain) {
    initialDomain = '; domain=' + domain
  }
  window.document.cookie = name + '=' + (value || '') + expires + initialDomain + '; path=/'
}

function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=-99999999;`
}

export const cookie = {
  get: getCookie,
  set: setCookie,
  delete: deleteCookie
}
